import { toaster } from "../components/toaster";
import { DefaultService } from "../generated";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useInvoicesQueue = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["invoicesQueue"],
    mutationFn: (invoiceUuid?: string) =>
      DefaultService.fakturInvoicesViewsInvoicesQueue({ invoiceUuid }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["invoiceDetail"] });
      queryClient.invalidateQueries({ queryKey: ["invoiceList"] });
      toaster.success({ title: "Fakturaer lagt til utsending" });
    },
  });
};
